import { useMobile } from "@with-nx/hooks-n-helpers";
import { DesignedTab } from "@with-nx/simple-ui/atoms";
import { useEffect, useState } from "react";
import { Box } from "simple-effing-primitive-layout";

import { RegisterForm } from "../auth/RegisterForm";
import { SignInFormContainer } from "../auth/SignInFormContainer";
import { useAuthForm } from "./useAuthForm";

interface TabbedAuthFormProps {
  borderless?: boolean;
  onTabChange?: (tab: string) => void;
  top?: number;
}
export const TabbedAuthForm = ({
  borderless,
  onTabChange,
  top,
}: TabbedAuthFormProps) => {
  const mobile = useMobile();
  const [tab, _tab] = useState("Sign In");
  const { form, _form } = useAuthForm();

  useEffect(() => {
    onTabChange?.(tab);
  }, [tab]);

  return (
    <Box
      top={top || 24}
      parse={`${borderless ? "" : "br:10"} oa:hidden ${mobile ? "ma:12" : ""}`}
      border={borderless ? "none" : "1px solid #FFFFFF1A"}
    >
      <>
        <Box
          parse="c:#1E242D pt:24 pr:24 pl:24"
          style={{
            borderBottom: "1px solid #2D3542",
            boxSizing: "border-box",
          }}
        >
          <DesignedTab
            tabs={["Sign Up", "Sign In"]}
            tab={tab}
            mode="line"
            press={(tab) => _tab(tab)}
          />
        </Box>

        <Box parse="c:#0E1115 pa:24">
          {tab === "Sign Up" && <RegisterForm />}
          {tab === "Sign In" && (
            <SignInFormContainer form={form} _form={_form} />
          )}
        </Box>
      </>
    </Box>
  );
};
